module.exports = __webpack_public_path__ + "static/media/mDeSaulnier.ff549f14.jpeg";